import { useState, useEffect, useCallback } from 'react';

import * as fp from 'lodash/fp';

import { FetchingDataStatus } from '~/types/utilities';

import { itemIndex } from '~/algolia/init';

import { PLATFORM_ID } from '~/globalVariables';

export default function useSearchStore({
  searchText,
  storeIds,
  tags,
}: {
  searchText: string;
  storeIds: Array<string>;
  tags: Array<string>;
}) {
  const [fetchingStatus, setFetchingStatus] = useState<FetchingDataStatus>(FetchingDataStatus.INIT);
  const [storesFulfillSearch, setStoresFulfillSearch] = useState<Array<string>>([]);

  const handleGetStoresFulfillSearch = useCallback(
    async (storeIds: Array<string>, tags: Array<string>, searchText: string) => {
      if (!searchText && !storeIds.length && !tags.length) {
        setFetchingStatus(FetchingDataStatus.INIT);
        setStoresFulfillSearch([]);
        return;
      }
      try {
        setFetchingStatus(FetchingDataStatus.LOADING);
        const res = await itemIndex.search<{ storeId: string; objectID: string }>(searchText, {
          filters: `isAvailable:true${
            fp.gt(storeIds.length, 0)
              ? ` AND ( ${storeIds.map((id) => `storeId:${id}`).join(' OR ')} )`
              : ''
          }${
            fp.gt(tags.length, 0)
              ? ` AND ( ${tags.map((tag) => `tags.${PLATFORM_ID}:${tag}`).join(' OR ')} )`
              : ''
          }`,
          attributesToRetrieve: ['storeId'],
          distinct: true,
          hitsPerPage: 1000,
        });
        const storesWithSearchResult = res.hits.filter((hit) => hit).map(({ storeId }) => storeId);
        setStoresFulfillSearch(fp.uniq(storesWithSearchResult));
        setFetchingStatus(FetchingDataStatus.SUCCESS);
      } catch (err) {
        setStoresFulfillSearch([]);
        setFetchingStatus(FetchingDataStatus.FAIL);

        console.error('algolia get store ids error', err);
      }
    },
    [],
  );

  useEffect(() => {
    handleGetStoresFulfillSearch(storeIds, tags, searchText);
  }, [storeIds, tags, searchText, handleGetStoresFulfillSearch]);

  return { fetchingStatus, storesFulfillSearch };
}
